import { render, staticRenderFns } from "./SubjectMaintenance.vue?vue&type=template&id=2fdfdf0b"
import script from "./SubjectMaintenance.js?vue&type=script&lang=js&external"
export * from "./SubjectMaintenance.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports